export const DEFAULT_MARKETING_PLAN_MONTHS = 12;
export const MAX_MARKETING_PLAN_MONTHS = 24;

export const DEFAULT_PREDICTION_SIZE = 12;
export const MAX_PREDICTION_SIZE = 36;

export function resolveMarketingPlanMonths(value) {
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed) || parsed < DEFAULT_MARKETING_PLAN_MONTHS) {
    return DEFAULT_MARKETING_PLAN_MONTHS;
  }
  if (parsed > MAX_MARKETING_PLAN_MONTHS) {
    return MAX_MARKETING_PLAN_MONTHS;
  }
  return parsed;
}

export function resolvePredictionSize(value) {
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed) || parsed < DEFAULT_PREDICTION_SIZE) {
    return DEFAULT_PREDICTION_SIZE;
  }
  if (parsed > MAX_PREDICTION_SIZE) {
    return MAX_PREDICTION_SIZE;
  }
  return parsed;
}

/** Ensures prediction horizon is at least the marketing plan length. */
export function resolvePredictionSizeWithMarketingPlan(predictionSize, marketingPlanMonths) {
  const marketingMonths = resolveMarketingPlanMonths(marketingPlanMonths);
  const resolvedPrediction = resolvePredictionSize(predictionSize);
  return Math.max(resolvedPrediction, marketingMonths);
}

export function getMarketingPlanMonthsOptions() {
  return Array.from(
    { length: MAX_MARKETING_PLAN_MONTHS - DEFAULT_MARKETING_PLAN_MONTHS + 1 },
    (_, index) => {
      const value = index + DEFAULT_MARKETING_PLAN_MONTHS;
      return { label: String(value), value: String(value) };
    }
  );
}

export function getPredictionSizeOptions() {
  return Array.from(
    { length: MAX_PREDICTION_SIZE - DEFAULT_PREDICTION_SIZE + 1 },
    (_, index) => {
      const value = index + DEFAULT_PREDICTION_SIZE;
      return { label: String(value), value: String(value) };
    }
  );
}

/** Mob field names included in scenario save / calc payload for the active plan length. */
export function buildActiveMobSettings(formValues, marketingPlanMonths) {
  const monthCount = resolveMarketingPlanMonths(
    marketingPlanMonths ?? formValues?.marketingPlanMonths
  );
  const settings = {};
  for (let monthIndex = 0; monthIndex < monthCount; monthIndex += 1) {
    settings[`mob${monthIndex}Marketing`] = formValues[`mob${monthIndex}Marketing`];
    settings[`mob${monthIndex}PercentOfMarketing`] =
      formValues[`mob${monthIndex}PercentOfMarketing`];
    settings[`mob${monthIndex}Funding`] = formValues[`mob${monthIndex}Funding`];
    settings[`mob${monthIndex}RevenueShare`] = formValues[`mob${monthIndex}RevenueShare`];
    settings[`mob${monthIndex}RevenueShareToCollect`] =
      formValues[`mob${monthIndex}RevenueShareToCollect`];
  }
  return settings;
}
